import { ref } from 'vue'

import type { AuthenticationState } from '../types'
import { useGlobals } from './useGlobals'

let initialised = false

const state = ref<AuthenticationState>('unauthenticated')
const isAuthenticated = ref<boolean>(false)
const token = ref<string | null>(null)

export function useAuth() {
  if (!initialised) {
    const { authenticationService } = useGlobals()
    state.value = authenticationService.state
    authenticationService.onStateChange(async (newState) => {
      state.value = newState
      isAuthenticated.value =
        newState === 'authenticated' || newState === 'reauthenticating'
      // For testing (shows in debug panel)
      token.value = await authenticationService.getToken()
    })

    initialised = true
  }

  return {
    state,
    isAuthenticated,
    token,
  }
}
